import { useState } from 'react';
// import './MainPage.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import Back from './bg.jpg';
import { useDropzone } from 'react-dropzone';
import { isValidPhoneNumber } from 'libphonenumber-js';

const FORM_URL =
  'https://script.google.com/macros/s/AKfycby_tKyJxW41eYOGC4rOFHPPuCL_zbA1IZzSSq9qsPtmo1jRPxz54oF7-RTUpy9fD0tQOQ/exec';

const TYPES = ['doc', 'docx', 'pdf'];
const token = '2XjFwIxoa4t7jql0bd';

const MainPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [isSending, setSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [formatSizeError, setFormatSizeError] = useState(false);
  const [addedFile, setAddedFile] = useState();
  const [isCheckboxActive, setCheckboxActive] = useState(false);

  const handleChangeField = (name, value) => {
    const newData = { ...data };
    newData[name] = value;
    setData(newData);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (
      (isCheckboxActive && !data.phone_number?.trim()) ||
      (!isCheckboxActive && data.phone_number?.trim()) ||
      !isValidPhone(data.phone_number)
    )
      return;

    setSending(true);

    try {
      const full_name = document.querySelector('#full_name')?.value || '';
      const phone_number = document.querySelector('#phone_number')?.value || '';
      const email_address = document.querySelector('#email_address')?.value || '';
      const preferred_location = document.querySelector('#preferred_location')?.value || '';
      const preferred_positions = document.querySelector('#preferred_positions')?.value || '';
      const salary_expectation = document.querySelector('#salary_expectation')?.value || '';
      const cover_letter = document.querySelector('#cover_letter')?.value || '';

      let fileBase64 = '';
      let fileName = '';
      let mimeType = 'application/octet-stream';

      const safeFullName = full_name
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9_-]/g, '');

      const extension = addedFile.name.includes('.') ? addedFile.name.split('.').pop() : 'bin';

      if (addedFile) {
        fileBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(addedFile);
        });

        fileName = addedFile.name;
        mimeType = addedFile.type || 'application/octet-stream';
      }

      const values = {
        token,
        full_name,
        preferred_location,
        email_address,
        phone_number,
        preferred_positions,
        salary_expectation,
        cover_letter,
        sender_type: 'candidate',
        fileBase64,
        fileName: `${safeFullName}_${Date.now()}.${extension}`,
        mimeType,
      };

      await fetch(`${FORM_URL}`, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });

      setIsSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  const isValidEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  const isValidPhone = phone => !phone?.trim() || isValidPhoneNumber(phone.trim(), 'US');

  const onDrop = acceptedFiles => {
    const file = acceptedFiles[0];
    addFileData(file);
  };

  const handleAddFile = e => {
    const file = e.target.files[0];
    addFileData(file);
  };

  const addFileData = file => {
    setFileSizeError(false);
    setFormatSizeError(false);

    const fileType = file?.name.split('.');
    if (file?.size > 4557600) setFileSizeError(true);
    else if (!TYPES.includes(fileType[fileType?.length - 1])) setFormatSizeError(true);
    else {
      setFileSizeError(false);
      setFormatSizeError(false);
      setAddedFile(file);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div className='page'>
      <Header />
      <MainScreen
        title='You Are So Much More Than a Title'
        text="Let's talk one-on-one about your career and unlock opportunities that match your true potential."
        background={Back}
      />

      <div className='pointsSection'>
        <span className='blockTitle'>Your Journey With Us</span>
        <span className='blockText'>A personalized approach to executive career advancement</span>
        <div className='points'>
          <div className='pointItem'>
            <span className='pointItemTitle'>Submit Your Profile</span>
            <span className='pointItemText'>
              Share your resume and tell us about your career goals, preferences, and what you're looking for in your next
              opportunity.
            </span>
            <span className='pointItemIcon'>1</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Personal Consultation</span>
            <span className='pointItemText'>
              A dedicated recruiter contacts you for an in-depth conversation about your ideal scenarios and career aspirations.
            </span>
            <span className='pointItemIcon'>2</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Profile Creation</span>
            <span className='pointItemText'>
              We hand-craft your comprehensive candidate profile that goes beyond credentials to showcase your unique value.
            </span>
            <span className='pointItemIcon'>3</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Opportunity Matching</span>
            <span className='pointItemText'>
              As positions become available, we act as your champion to create win-win placements that align with your goals.
            </span>
            <span className='pointItemIcon'>4</span>
          </div>
        </div>
      </div>

      <div className='mainFormContainer'>
        <div className='mainForm'>
          <span className='blockTitle'>Submit Your Resume</span>
          <span className='blockText'>Upload your CV and let our recruiters match you with perfect opportunities</span>
          <div className='mainFormHolder'>
            <div className='mainFormContacts'>
              <span className='mainFormTitle'>Send Your resume</span>
              {/* <zapier-interfaces-page-embed
                page-id='cmkfr8f9h001g6h2hnczu3stv'
                query-params='full_name=John%20Doe&email=test@example.com'
                style={{ width: '900px', height: '1180px' }}
              ></zapier-interfaces-page-embed> */}

              <div className='mainFormOverlay'>
                {isSuccess && (
                  <div className='mainFormSuccess'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120' fill='none'>
                      <path
                        d='M45 60L55 70L75 50M110 60C110 87.6142 87.6142 110 60 110C32.3858 110 10 87.6142 10 60C10 32.3858 32.3858 10 60 10C87.6142 10 110 32.3858 110 60Z'
                        stroke='#14A852'
                        stroke-width='5'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                    <span className='mainFormSuccessTitle'>Success!</span>
                    <span className='mainFormSuccessText'>
                      We’ve received your request and will contact you within 1 business day.
                    </span>
                  </div>
                )}
                <span className='mainFormTitle'>Send Hiring Request</span>

                <div className='mainFormFields'>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Full Name <span className='mainFormRequiredMark'>*</span>
                    </label>
                    <input
                      className='mainFormInput'
                      value={data.full_name}
                      id='full_name'
                      onChange={e => handleChangeField('full_name', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Email Address <span className='mainFormRequiredMark'>*</span>
                    </label>
                    <input
                      className='mainFormInput'
                      value={data.email_address}
                      id='email_address'
                      onChange={e => handleChangeField('email_address', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Phone Number{isCheckboxActive && <span className='mainFormRequiredMark'> *</span>}
                    </label>
                    <input
                      className='mainFormInput'
                      value={data.phone_number}
                      id='phone_number'
                      onChange={e => handleChangeField('phone_number', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>Preferred Positions</label>
                    <input
                      className='mainFormInput'
                      value={data.preferred_positions}
                      id='preferred_positions'
                      onChange={e => handleChangeField('preferred_positions', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>Preferred Location</label>
                    <input
                      className='mainFormInput'
                      value={data.preferred_location}
                      id='preferred_location'
                      onChange={e => handleChangeField('preferred_location', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>Salary Expectation</label>
                    <input
                      className='mainFormInput'
                      value={data.salary_expectation}
                      id='salary_expectation'
                      onChange={e => handleChangeField('salary_expectation', e.target.value)}
                    />
                  </div>

                  <div className='mainFormTextarea'>
                    <label className='mainFormLabel'>Cover Letter / Additional Info</label>
                    <textarea
                      className='mainFormComment'
                      value={data.cover_letter}
                      row={3}
                      id='cover_letter'
                      onChange={e => handleChangeField('cover_letter', e.target.value)}
                    ></textarea>
                  </div>
                  <div
                    className={cn(
                      'mainFormUploadBlock',
                      fileSizeError && 'mainFormUploadBlockError',
                      formatSizeError && 'mainFormUploadBlockError',
                    )}
                    {...getRootProps()}
                  >
                    <input type='file' className='mainFormUploadInput' onChange={e => handleAddFile(e)} {...getInputProps()} />
                    <span className='mainFormUploadTitle'>Click to upload your resume</span>
                    <span className='mainFormUploadText'>
                      {formatSizeError
                        ? 'Unsupported file format. Please upload a different file.'
                        : fileSizeError
                        ? 'This file is too large. Please upload a smaller file.'
                        : !!addedFile
                        ? 'File uploaded successfully.'
                        : 'Supported formats: PDF, DOC, DOCX (max 5 MB).'}
                    </span>
                  </div>
                </div>
                <div
                  className={cn(
                    'mainFormAgreeCheck',
                    !isCheckboxActive && data.phone_number?.trim() && 'mainFormAgreeCheckError',
                  )}
                >
                  <label>
                    <input
                      type='checkbox'
                      checked={isCheckboxActive}
                      onChange={e => setCheckboxActive(e.target.checked)}
                    />
                    <span>
                      By checking this box and providing my phone number, I agree to receive SMS/text messages from American
                      Consultants regarding job opportunities, interview scheduling, application updates, onboarding information,
                      and service-related notifications. Message frequency varies (up to 10 msgs/month). Msg & data rates may
                      apply. Reply STOP to opt out or HELP for help. Mobile information and consent to receive SMS will not be
                      shared with third parties or affiliates for marketing or promotional purposes. See our{' '}
                      <a
                        href='https://app.termly.io/policy-viewer/policy.html?policyUUID=d94582df-8db3-4369-9a8a-e1e1f088c58d'
                        target='_blank'
                      >
                        Privacy Policy
                      </a>{' '}
                      and{' '}
                      <a
                        href='https://app.termly.io/policy-viewer/policy.html?policyUUID=c39976da-bc93-427b-a511-25e33d082944'
                        target='_blank'
                      >
                        Terms & Conditions
                      </a>{' '}
                      for details.
                    </span>
                  </label>
                </div>
                <div
                  className={cn(
                    'mainFormButton',
                    (!data.full_name?.trim() ||
                      !data.email_address?.trim() ||
                      (isCheckboxActive && !data.phone_number?.trim()) ||
                      (!isCheckboxActive && data.phone_number?.trim()) ||
                      !isValidPhone(data.phone_number) ||
                      !isValidEmail(data.email_address) ||
                      isSending) &&
                      'mainFormButtonDisabled',
                  )}
                  onClick={e => handleSubmit(e)}
                >
                  Find Your Next Job
                </div>
              </div>
              {/* </div> */}
            </div>
            <div className='mainFormContacts'>
              <span className='mainFormTitle'>Contact Us</span>
              <a className='mainFormEmail' href='mailto:renee@thehealthcarepeople.com'>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                  <path
                    d='M22 6.99976L13.03 12.6998C12.7213 12.8932 12.3643 12.9958 12 12.9958C11.6357 12.9958 11.2787 12.8932 10.97 12.6998L2 6.99976M4 3.99976H20C21.1046 3.99976 22 4.89519 22 5.99976V17.9998C22 19.1043 21.1046 19.9998 20 19.9998H4C2.89543 19.9998 2 19.1043 2 17.9998V5.99976C2 4.89519 2.89543 3.99976 4 3.99976Z'
                    stroke='#3D424B'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
                renee@thehealthcarepeople.com
              </a>
              <span className='mainFormPhone'>
                <svg width='24' height='25' viewBox='0 0 24 25' fill='none'>
                  <path
                    d='M21.9999 17.5339V20.5339C22.0011 20.8124 21.944 21.088 21.8324 21.3432C21.7209 21.5984 21.5572 21.8275 21.352 22.0157C21.1468 22.204 20.9045 22.3473 20.6407 22.4366C20.3769 22.5258 20.0973 22.5589 19.8199 22.5339C16.7428 22.1995 13.7869 21.148 11.1899 19.4639C8.77376 17.9285 6.72527 15.88 5.18993 13.4639C3.49991 10.8551 2.44818 7.88486 2.11993 4.79387C2.09494 4.51733 2.12781 4.23863 2.21643 3.97549C2.30506 3.71236 2.4475 3.47056 2.6347 3.26549C2.82189 3.06042 3.04974 2.89658 3.30372 2.78439C3.55771 2.6722 3.83227 2.61413 4.10993 2.61387H7.10993C7.59524 2.60909 8.06572 2.78095 8.43369 3.0974C8.80166 3.41385 9.04201 3.85331 9.10993 4.33387C9.23656 5.29393 9.47138 6.23659 9.80993 7.14387C9.94448 7.50179 9.9736 7.89078 9.89384 8.26475C9.81408 8.63871 9.6288 8.98198 9.35993 9.25387L8.08993 10.5239C9.51349 13.0274 11.5864 15.1003 14.0899 16.5239L15.3599 15.2539C15.6318 14.985 15.9751 14.7997 16.3491 14.72C16.723 14.6402 17.112 14.6693 17.4699 14.8039C18.3772 15.1424 19.3199 15.3772 20.2799 15.5039C20.7657 15.5724 21.2093 15.8171 21.5265 16.1914C21.8436 16.5657 22.0121 17.0434 21.9999 17.5339Z'
                    stroke='#3D424B'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
                913-322-2245
              </span>
              <span className='mainFormText'>Refer a Friend</span>
              <span className='mainFormInfo'>
                Know someone looking for healthcare opportunities? Refer them and earn up to $1,000 when they get hired!
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainPage;
